import { render, staticRenderFns } from "./ModalTemplates.vue?vue&type=template&id=0709477a&scoped=true"
import script from "./ModalTemplates.vue?vue&type=script&lang=js"
export * from "./ModalTemplates.vue?vue&type=script&lang=js"
import style0 from "./ModalTemplates.vue?vue&type=style&index=0&id=0709477a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0709477a",
  null
  
)

export default component.exports